<template>
    <div class="user-rule-container">
        <p><strong>窝窝投网络服务平台用户协议</strong></p>

<p><code>  </code>尊敬的用户： </p>

<p>在您成为窝窝投注册用户，使用窝窝投提供的服务之前，请您认真阅读本《窝窝投网络服务平台用户协议》（以下简称“本协议”），更好地了解我们所提供的服务以及您享有的权利及承担的义务。您一旦点击确认注册并使用窝窝投服务，即表示您已经确认并接受了本协议中的全部条款。</p>

<p><code> </code>本协议系由您（以下简称“用户”或“您”）与上海德益文智能科技有限公司（以下简称“德益文公司”或“我们”）（公司注册地址：黄浦区金陵东路2号四楼，联系电话：021-54363959）就德益文公司提供的窝窝投网络服务平台（以下简称“平台”或“窝窝投”）所订立的相关权利义务规范。窝窝投是一个为平台认证商家及您间建立推广服务合作平台的服务软件，请您在注册、使用窝窝投之前，认真阅读以下条款，我们在此认为您具备阅读并理解本协议全部内容的能力，如您选择点击或勾选相关内容，则表示您与德益文公司达成协议的同时亦确认您具备前述阅读、理解的能力。</p>

<p>一、注册条款的接受</p>

<p><code> </code>一旦您在注册页面点击或勾选“阅读并同意接受平台用户协议及个人信息保护政策”相关内容后，即表示您已经阅读并且同意与德益文公司达成协议，成为窝窝投的用户，并接受本协议中的全部注册条款以及德益文公司《窝窝投网络服务平台用户个人信息保护政策》和本平台内公布的其他专项协议或规则，包括但不限于与平台认证商家相关的《商家任务信息发布管理规范》的所有条款的约束。</p>

<p>二、用户注册条件</p>

<p><code> </code>申请注册成为窝窝投的用户应满足：在注册之日必须年满18周岁以上。如您在注册之日未满18周岁，但在注册页面选择点击或勾选相关内容的，则本协议不生效。在此情况下如您因使用本平台而产生任何损害，平台均不负任何责任，如给平台或德益文公司造成损失的，我们保留向您追索的权利。故此，请在此特别注意并确认，您在注册及使用平台时已经年满18周岁。 </p>

<p>1.为了更好地享有窝窝投平台服务，成功与平台认证商家提供推广服务合作，用户应充分满足窝窝投注册机制的要求，向窝窝投提供用户本人真实、准确、最新及完整的资料；注册并认证成为平台的用户应确保前述资料的真实性。 </p>

<p>2.若用户提供任何错误、不实或不完整的资料，或窝窝投有理由怀疑资料存在错误、不实或不完整及违反用户注册条款的，或窝窝投有理由怀疑其用户资料、言行等有悖于平台成立初衷、社会公序良俗的，则窝窝投有权修改用户的注册昵称、个人说明及发布的信息、评论等，或采取暂停或终止为您提供窝窝投的全部或部分服务的措施。 </p>

<p>3.若用户提供虚假身份信息进行注册，视为严重违反本协议，窝窝投有权暂停或终止用户账号并停止提供服务。虚假注册并使用虚假注册信息与平台认证商家建立推广服务合作给窝窝投造成经济、名誉等任何损失的，窝窝投将追究该用户的法律责任。 </p>

<p>三、用户账号、密码及安全 </p>

<p>1.在完成用户注册程序之后，用户将收到一个密码及账号。用户有义务保证密码及账号的安全。用户应对使用该密码及账号所进行的一切活动负全部责任，包括任何经由平台上传、发送电子邮件或任何其它方式传送的文字、照片、图形、视讯及其它资料，无论系公开还是私下传送，均由内容提供者（用户）承担相应责任。 </p>

<p>2.用户的密码或账号遭到未获授权的使用，或者发生任何其他安全问题时，用户应立即通知窝窝投。由于用户使用不当或者其他非因窝窝投原因导致的账号、密码泄漏，进而导致其资料、信息泄漏的，由用户承担其造成的不利后果。 </p>

<p>3.用户不得将账号主动告知第三方或提供给第三方进行使用，例如将账号提供给第三方供第三方为平台认证商家提供推广服务，或则将账户提供给未满18周岁的人士使用等。 </p>

<p>四、服务说明 </p>

<p>1.窝窝投通过国际互联网为用户提供服务，用户应自行配备进入国际互联网所必需的设备，包括计算机、手机或其它设备，并自行支付登录国际互联网所需要的费用。 </p>

<p>2.窝窝投在提供网络服务时，可能会对部分网络服务收取一定的费用，在此情况下，会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。 </p>

<p>3.窝窝投不会以任何名义要求用户向平台工作人员银行账号支付任何费用；用户明确知晓窝窝投不会以任何名义要求用户向平台工作人员或任何个人银行账号支付任何费用，用户向任何平台工作人员或任何个人银行账户支付任何费用导致用户财产损失的，均由用户本人承担相应损失，与平台无关。 </p>

<p>4.基于风控策略/安全防控/服务政策的需要，窝窝投可能要求部分用户提供补充资料，具体要求将在相关页面上做出明确指示。如相关用户拒绝提供前述补充资料或未按期提供前述补充资料，窝窝投有权视情况暂停或终止向该用户提供部分或全部服务。 </p>

<p>5.对于利用窝窝投进行非法活动，或言行背离窝窝投设立初衷的，窝窝投将严肃处理，包括将其列入黑名单、在必要的情形下将其被投诉的情形公之于众、作出删除用户账号等处罚措施，给窝窝投造成经济或名誉等任何损失的，窝窝投将依法追究其法律责任。 </p>

<p>6.窝窝投有权通过拨打电话、发送短信或电子邮件等任何一种方式，告知用户窝窝投服务相关的广告信息、促销优惠等营销信息，以及邀请用户参与版本测试、用户体验反馈等活动。除系统通知或重要信息外，用户可以通过窝窝投提供的方式选择不接收上述信息。 </p>

<p>7.为了提高用户与平台认证商家所发布任务的匹配成功率及效率，便于用户与平台认证商家沟通，您可以登录窝窝投账号通过IM即时通讯服务并与认证商家进行聊天、发送您的简介、沟通任务等。 </p>

<p>五、有限责任条款 </p>

<p>1.窝窝投将尽力为用户提供安全、及时、准确及高质量的服务，但不保证一定能满足用户的所有要求及期望，也不保证服务不会中断，并且对服务的及时性、安全性、准确性都不作保证。除另有约定外，用户因无法使用窝窝投服务，或使用服务未达到心理预期的，窝窝投不承担责任。 2.对于用户通过平台传送的内容，窝窝投会尽合理努力按照国家有关规定严格审查，但无法完全控制通过平台传送的内容，并不保证内容的正确性、完整性或品质。因此用户在使用窝窝投服务时，可能会接触到令人不快、不适或令人厌恶的内容。在任何情况下，窝窝投均不为用户通过平台传送的任何内容负责。但窝窝投有权依法停止传输任何前述内容并采取相应措施，包括但不限于暂停或终止用户使用平台全部或部分的服务、保存有关记录，并根据国家法律法规在必要时向有关机关报告并配合有关机关的行动。 </p>

<p>2.对于窝窝投提供的各种第三方广告信息、链接、资讯等，窝窝投不保证其内容的正确性、合法性或可靠性，相关责任由广告主承担；并且，对于用户经由平台提供的各种第三方广告信息、链接、资讯等与广告主进行联系或商业往来，完全属于用户及广告主之间的行为，与窝窝投无任何关联。对于前述商业往来对用户产生的任何损害或损失，窝窝投不承担任何责任，由用户自行承担。 </p>

<p>3.对于用户及平台认证商家上传的照片、资料、证件、图片及视频等，窝窝投已采用相关措施并已尽合理努力进行审核，但不保证其内容的正确性、合法性或可靠性，相关责任均由上传上述内容的用户及平台认证商家承担。 </p>

<p>4.用户应对窝窝投上的其他用户及平台认证商家发布的内容自行加以判断，并承担因使用内容或建立推广合作而引起的所有风险，包括但不限于因对内容的正确性、完整性或实用性的依赖而产生的风险。窝窝投无法且不会对因前述风险而导致用户的任何损失或损害承担责任。 </p>

<p>5.是否通过平台下载或取得任何资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户任何设备的任何损坏或数据丢失等后果，窝窝投不承担任何责任。 </p>

<p>6.对于窝窝投在线上或线下策划、发起、组织或是承办或是协办的任何相关的活动（包括但不限于收取费用及完全公益的活动），窝窝投均不对上述活动向用户作出任何保证或承诺，也不担保活动期间其他用户或平台认证商家自身行为的合法性、合理性。由此产生的任何对用户个人或者他人的人身、名誉或其他损害，均应由行为实施主体承担责任，窝窝投不承担任何责任。 </p>

<p>7.对于用户的投诉，窝窝投将尽合理努力进行核实和处理，但不保证一定能满足投诉者的要求。窝窝投有权自行决定是否向公众或向被投诉者公开投诉内容。对于投诉内容侵犯用户隐私权、名誉权等合法权益的，所有法律责任由投诉者承担，与窝窝投无关。 </p>

<p>六、用户权利 </p>

<p>用户对于自己的个人信息享有以下权利： </p>

<p>1.随时查询及请求阅览，但因极少数特殊情况（如被平台加入黑名单等）无法查询及提供阅览的除外； </p>

<p>2.随时请求补充或更正，但因极少数特殊情况（如平台或有关机关为司法程序保全证据等）无法补充或更正的除外； </p>

<p>3.随时申请注销窝窝投账号。关于注销账号的相关流程，请参见第十四条用户注销条款。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。 </p>

<p>七、用户应承诺其平台使用行为遵守以下规定 </p>

<p>1.窝窝投提醒用户在使用窝窝投服务时，应遵守《中华人民共和国民法典》、《中华人民共和国著作权法》、《全国人民代表大会常务委员会关于维护互联网安全的决定》、《中华人民共和国保守国家秘密法》、《中华人民共和国电信条例》、《中华人民共和国计算机信息系统安全保护条例》、《计算机信息系统国际联网保密管理规定》、《互联网信息服务管理办法》、《计算机信息网络国际联网安全保护管理办法》、《互联网电子公告服务管理规定》、《中华人民共和国网络安全法》、《网络信息内容生态治理规定》、《中华人民共和国计算机信息网络国际联网管理暂行规定》等相关中国法律法规的规定。 </p>

<p>2.在任何情况下，如果窝窝投有理由认为用户使用窝窝投服务过程中的任何行为，包括但不限于用户的任何言论和其它行为违反或可能违反上述法律法规的任何规定，窝窝投可在不经任何事先通知的情况下终止向用户提供服务。 </p>

<p>3.用户承诺在使用窝窝投期间，遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等必要底线。 4.您理解并同意，本平台仅作为提供用户为平台认证商家提供推广服务机会的平台，您必须为您自己的注册、认证账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。 </p>

<p>八、禁止用户利用窝窝投从事下列行为 </p>

<p>禁止用户在窝窝投或利用窝窝投提供的服务制作、发送、发布或传播违反国家相关法律法规、必要底线、本平台规则的信息或从事违反前述规定/规则的活动，主要表现为： </p>

<p>1.反对宪法所确定的基本原则的； </p>

<p>2.违反中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的内容的； </p>

<p>3.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； </p>

<p>4.损害国家荣誉和利益的； </p>

<p>5.煽动民族仇恨、民族歧视、破坏民族团结的； </p>

<p>6.破坏国家宗教政策，宣扬邪教和封建迷信的； </p>

<p>7.散布谣言、扰乱社会秩序、破坏社会稳定的； </p>

<p>8.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； </p>

<p>9.侮辱或者诽谤他人，侵害他人合法权益的； </p>

<p>10.含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或有悖道德、令人反感的内容的；</p>

<p>11.使用窝窝投服务过程中，以任何方式危害其他用户/平台认证商家/平台的合法权益的； </p>

<p>12.冒充他人或机构，包括但不限于冒充窝窝投工作人员或以不实的方式陈述或谎称与他人或机构有关的； </p>

<p>13.发布、传播侵犯他人的肖像权、名誉权、隐私权、专利权、商标权、著作权、商业秘密的信息或言论的； </p>

<p>14.将病毒或其它计算机代码、档案和程序以上传、发送电子邮件或其它方式传送的；</p>

<p>15.跟踪或以其它方式骚扰其他用户/平台认证商家的； </p>

<p>16.未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的的； </p>

<p>17.以任何方式干扰或企图干扰窝窝投的任何服务正常运行，或者制作、发布、传播上述工具、方法的； </p>

<p>18.未能按照本平台的流程、规则进行注册、认证或使用本平台服务的，违反本平台服务限制，或采取任何规避前述流程、规则、限制的措施的； 19.未经窝窝投的许可使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本平台的； </p>

<p>19.利用窝窝投账号或本平台服务从事包括但不限于欺诈、传销、刷流量、好评、违法物品营销等任何违法兼职或犯罪活动的； </p>

<p>20.仿冒、混淆他人账号昵称、头像、功能介绍与平台认证商家/平台接触的； </p>

<p>21.未经窝窝投的许可，以任何目的自行或授权、允许、协助任何第三人对平台内的任何信息内容进行非法获取，用于商业用途或其他任何目的的。“非法获取”是指采用包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为的； </p>

<p>22.为任何注册用户或非注册用户提供自动登录到本平台、代办或协助他人代办身份认证服务的或代售身份认证所需的相关材料或凭据等行为； </p>

<p>23.任何导致或可能导致窝窝投与第三方产生纠纷、争议或诉讼的行为。 九、特别规定 </p>

<p>1.用户如违反本协议第八条，窝窝投有权随时暂停或终止向该用户提供服务并无需事先通知。 </p>

<p>2.用户有下列行为或发布/散布/传播相关信息的，窝窝投在发现或接到投诉后，有权采取冻结账号、升级认证或以其他方式暂停或终止向该用户提供服务，并要求用户承担相应的损害赔偿责任： </p>

<p>（1）涉及广告（寻求推广服务提供者合作的）、传销或直销等内容； </p>

<p>（2）涉及色情、淫秽内容； </p>

<p>（3）涉及违法/政治敏感内容； </p>

<p>（4）虚假信息，包括但不限于虚假描述自身情况以促成为平台认证商家提供推广服务的； </p>

<p>（5）涉及人身攻击或其他侵害他人权益的内容；</p>

<p>（6）以各种名义骗取其他用户/平台认证商家财物的； </p>

<p>（7）骚扰其他用户/平台认证商家/平台； </p>

<p>（8）不符合窝窝投相关服务性质的信息，如鸡汤、段子、水贴等； </p>

<p>（9）利用窝窝投可能存在的漏洞恶意要求支付推广费或其他费用的； （10）其他违反法律法规或国家政策或损害窝窝投、平台认证商家及其他用户合法权益的行为。 根据我国现行的法律法规等相关规定，如用户实施前述规定涉及的行为的，窝窝投有权随时拒绝向该用户提供或继续提供服务，并可采取相关处理措施，包括但不限于“永久性封禁账号”、“永久性将其设备号、手机号等相关信息冻结”或“永久性加入‘黑名单’”等。</p>

<p>十、个人信息保护政策 </p>

<p>窝窝投将依法保护用户个人信息和隐私信息。有关内容详见《窝窝投网络服务平台用户个人信息保护政策》。 </p>

<p>十一、极光推送信息收集说明 </p>

<p>为实现版本统计功能，优化平台服务体验，我们可能通过极光推送服务收集您的应用安装、更新、卸载等相关信息。该等信息的收集、使用限于版本统计分析之目的，我们将依据《窝窝投网络服务平台用户个人信息保护政策》及相关法律法规对该信息进行保护，未经您的明示同意，不会将其用于本协议约定以外的其他用途。您有权通过平台提供的相关设置功能选择是否提供上述信息，若您选择不提供，可能导致我们无法准确进行版本统计，但不影响您使用平台的其他核心服务。 </p>

<p>十二、关于用户在窝窝投上传的内容 </p>

<p>1.用户在窝窝投上传的内容（包括但不限于照片、文字等推广服务反馈或其他由用户自行发布的内容），视为用户授予窝窝投免费、非独家的使用权，窝窝投有权为展示、传播及推广前述内容的目的，对上述内容进行复制、修改、出版等。该使用权持续至用户书面通知窝窝投不得继续使用，且窝窝投实际收到该等书面通知时止。窝窝投无须删除或追回或以任何一种形式撤销已使用的内容，亦无须向用户支付任何费用。 </p>

<p>2.因用户上传的内容侵犯第三方权利，而导致任何第三方向窝窝投提出侵权赔偿或索赔要求的，用户应承担全部责任。 </p>

<p>3.任何第三方对于用户在窝窝投的公开使用区域上传的内容进行复制、修改、编辑、传播等行为的，该行为产生的法律后果和责任均由行为人承担，与窝窝投无关。 </p>

<p>十三、关于IM即时通讯服务 </p>

<p>1.用户在接受本协议与平台认证商家或其他用户通过IM即时通讯服务进行沟通（包括但不限于进行推广任务沟通、心得分享）时，应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚，并保证所传输的信息真实性等必要底线。 </p>

<p>2.用户通过IM即时通讯服务与他人在线聊天下产生的文字、语音及视频等形式的沟通信息，窝窝投将会根据法律规定暂时存储，且仅用于投诉举报的处理、安全防控及离线暂存功能的实现。 </p>

<p>3.窝窝投对上述信息的采集、传输及存储均会采取加密、防泄露等相关措施，基于安全政策考虑，通常我们会存储一定期限。 </p>

<p>4.为保护其他用户隐私，您不得下载、传播或公开发布本条规定的其他用户/平台认证商家的通讯信息，如任务沟通信息等。如因此造成窝窝投损失，或者侵害平台认证商家或其他用户权益的，您应当承担违约责任或赔偿责任。 </p>

<p>十四、信息储存和限制</p>

<p>窝窝投有权制定一般措施及限制，包括但不限于平台将保留的电子邮件、聊天信息、所上传的最长期间、每个账号可收发沟通讯息的最大数量及可收发的单个消息的大小。通过服务存储或传送的任何信息、通讯资料和其他内容，如被删除或未予储存，窝窝投不承担任何责任。 </p>

<p>十五、用户注销条款 </p>

<p>1.用户若反对本协议的任何注册条款的内容或对之后注册条款修改有异议的，或对窝窝投服务不满的，用户有以下权利：不再使用窝窝投服务。结束用户服务的同时，用户使用窝窝投服务的权利立即终止，窝窝投不再对用户承担任何义务。 </p>

<p>2.用户可以通过邮箱申请注销账号，窝窝投将在用户提出注销申请的15个工作日内完成注销审核；通过审核的，窝窝投将永久性注销该账户，我们将尽快删除您的个人信息或作匿名化处理；审核未通过的，窝窝投将提示用户未能通过的原因，若因用户在确认注销审核通过前删除软件而不知晓注销申请未通过的，由用户自行承担相应后果。 </p>

<p>十六、禁止商业行为 </p>

<p>1.用户同意不对窝窝投提供的服务或服务的任何部分，进行复制、拷贝、出售、转售或用于任何其他商业目的。 </p>

<p>2.用户禁止发布关于寻求推广服务提供者合作的讯息，如有，我们将终止用户使用窝窝投服务的资格。用户如需发布关于寻求推广服务提供者合作的讯息，应联系平台并注册成为平台认证商家。</p>

<p>十七、违约责任 </p>

<p>1.用户使用虚假身份信息、发布寻求推广服务提供者合作讯息、发布含有传销、色情、反动等严重违法内容、对外传播与平台认证商家间推广服务信息等通讯记录等行为的，视为严重违反本协议，应当承担给窝窝投造成的经济损失和名誉损失。 </p>

<p>2.因用户通过窝窝投提供服务或传送内容而产生违反本服务条款的行为、或侵害任何第三方任何合法权益而导致任何第三人对窝窝投提出任何索赔或请求，用户应当赔偿窝窝投或其他合作伙伴的损失，包括但不限于赔偿金额、律师费等。 </p>

<p>3.用户在投诉其他用户有违法行为或违反本注册条款情形时，投诉者应承担不实投诉所产生的全部法律责任。如侵犯他人的合法权益，投诉人应自行承担全部法律责任。如给窝窝投造成损失的，投诉人应对窝窝投承担相应的赔偿责任。 </p>

<p>十八、本协议条款的变更和修改 </p>

<p>窝窝投有权依法随时对本协议的任何条款进行变更和修改。一旦发生条款变动，我们将在平台内进行更新及提示，或将最新版本的《窝窝投网络服务平台用户协议》以系统消息、弹窗、电子邮件或页面公告等任何一种或多种形式发送给用户阅读及确认接收。用户如果不同意条款的修改，应主动停止使用窝窝投或申请注销窝窝投账号。否则，如果用户继续使用用户账号，则视为用户已经接受本协议全部条款的修改。 </p>

<p>十九、不可抗力 </p>

<p>1.“不可抗力”是指窝窝投不能合理控制、不可预见或即使预见亦无法避免的事件，包括但不限于政府行为、自然灾害、战争、黑客袭击、电脑病毒、网络故障等。不可抗力可能导致窝窝投无法访问、访问速度缓慢、存储数据丢失、用户个人信息泄漏等不利后果。 </p>

<p>2.遭受不可抗力事件时，窝窝投可中止履行本协议项下的义务直至不可抗力的影响消除，并且不因此承担任何违约责任或侵权责任；但应尽最大努力克服该事件，减轻其负面影响。 </p>

<p>二十、通知 </p>

<p>窝窝投向用户发出的通知，将采用系统消息、弹窗、电子邮件或页面公告等任何一种或多种形式。本《窝窝投网络服务平台用户协议》的条款修改或其他事项变更时，窝窝投可以以上述形式进行通知。 </p>

<p>二十一、法律的适用和管辖 </p>

<p>本协议的生效、履行、解释及争议解决均适用中华人民共和国的现行法律，所发生的争议应提交上海国际经济贸易仲裁委员会，按照其届时有效的仲裁规则进行仲裁，仲裁裁决为终局裁决，对双方均有约束力。仲裁费用由败诉方承担，除非仲裁裁决另有规定。本协议因与中华人民共和国现行法律相抵触而导致部分条款无效的，不影响其他条款的效力。</p>

    </div>
</template>

<script>
export default {
    name: "UserRule",
};
</script>

<style scoped>
.user-rule-container {
    padding: 0 15px;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    overflow-x: hidden;
}

</style>
